import styled, { css } from 'styled-components'

export const Input = styled.input`
  width: calc(1ch + 40px);
  padding: 20px 18px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid var(--text);

  font-size: 20px;
  font-weight: bold;
  color: var(--text);

  ${props => {
    if (props.responseType == 'error') {
      return css`
        border-color: var(--toastErrorPrimary);
      `
    } else if (props.responseType == 'success') {
      return css`
        border-color: var(--toastSuccessPrimary);
      `
    }
  }}
`
